















































































import Vue from 'vue';
import { Dayjs, OpUnitType } from 'dayjs';

export type DayTileType = {
        day: number,
        month:number
        year:number
        isToday: boolean,
        notInVisibleMonth: boolean,
        disabled: boolean
      };

export default Vue.extend({
  props: {
    value: { default: undefined, type: String },
    visibleYear: { default: undefined, type: Number },
    visibleMonth: { default: undefined, type: Number },
    dayStartOfWeek: { type: Number, default: 1 },
    min: { type: String, default: undefined },
    max: { type: String, default: undefined },
    disabledDates: { type: Array, default: () => ([]) },
    noYearSteppers: { type: Boolean, default: false },
    noMonthSteppers: { type: Boolean, default: false },
  },
  data: () => ({
    focusedDay: Vue.$date.now().day() as number,
    innerVisibleMonth: Vue.$date.now().month() + 1 as number,
    innerVisibleYear: Vue.$date.now().year() as number,
    selectedDate: undefined as Dayjs | undefined,
    dayNames: [] as string[],
  }),
  computed: {
    visibleYearDate: {
      get() {
        return `${this.innerVisibleYear}-1-1`;
      },
      set(value: string) {
        this.innerVisibleYear = this.$date(value)?.year();
      },
    },
    selectedDateMonth() {
      if (!this.selectedDate) {
        return undefined;
      }
      return this.selectedDate.month() + 1;
    },
    selectedDateDay() {
      return this.selectedDate?.date();
    },
    selectedDateYear() {
      return this.selectedDate?.year();
    },
    displayMonth(): string {
      return this.$date(`${this.innerVisibleYear}-${this.innerVisibleMonth}-${this.focusedDay}`).format('MMMM');
    },
    dayTiles() {
      const firstDayMonthObj = this.$date(`${this.innerVisibleYear}-${this.innerVisibleMonth}-1`);
      const firstDayOfMonthNr = firstDayMonthObj.day();
      let nrDaysPreviousMonth = firstDayOfMonthNr - this.dayStartOfWeek;
      if (nrDaysPreviousMonth < 0) {
        nrDaysPreviousMonth += 7;
      }
      let currentDateObj = firstDayMonthObj.subtract(nrDaysPreviousMonth + 1, 'day');
      const computedMonthDays = {} as Record<string, DayTileType[]>;
      for (let i = 0; i < 42; i += 1) {
        currentDateObj = currentDateObj.add(1, 'day');
        const day = currentDateObj.date();
        const month = currentDateObj.month() + 1;
        const year = currentDateObj.year();
        const currentWeek = Math.floor(i / 7).toString();
        computedMonthDays[currentWeek] = computedMonthDays[currentWeek] ?? [];
        const isToday = this.$date.now().isSame(currentDateObj, 'day');
        const notInVisibleMonth = month !== this.innerVisibleMonth;

        let isBeforeMin = false;
        if (this.min) {
          isBeforeMin = currentDateObj.isBefore(this.$date(this.min));
        }
        let isAfterMax = false;
        if (this.max) {
          isAfterMax = currentDateObj.isAfter(this.$date(this.max));
        }
        const disabledDateObjs = this.disabledDates.map((date) => this.$date(date as string));
        const closureCurrentDateObj = currentDateObj;
        const isDisabled = !!disabledDateObjs.find((date) => closureCurrentDateObj.isSame(date));
        const disabled = isBeforeMin || isAfterMax || isDisabled;
        computedMonthDays[currentWeek].push({
          year, month, day, isToday, notInVisibleMonth, disabled,
        });
      }
      return computedMonthDays;
    },
  },
  watch: {
    visibleYear: {
      immediate: true,
      handler() {
        this.innerVisibleYear = this.visibleYear;
      },
    },
    visibleMonth: {
      immediate: true,
      handler() {
        this.innerVisibleMonth = this.visibleMonth;
      },
    },
    innerVisibleMonth() {
      this.$emit('visible-month-change', this.innerVisibleMonth);
    },
    innerVisibleYear() {
      this.$emit('visible-year-change', this.innerVisibleYear);
    },
    value: {
      immediate: true,
      handler() {
        if (this.value) {
          const dateObj = this.$date(this.value);
          this.selectedDate = dateObj;
          this.focusedDay = dateObj.date();
          this.innerVisibleMonth = dateObj.month() + 1;
          this.innerVisibleYear = dateObj.year();
        }
      },
    },
  },
  mounted() {
    if (!this.innerVisibleMonth) {
      this.innerVisibleMonth = this.$date.now().month() + 1;
      this.innerVisibleYear = this.$date.now().year();
    }
  },
  beforeMount() {
    const tranlsation = this.$translation.get() === 'en' ? 'en': `${this.$translation.get()}-ch`;
    this.$date.locale(tranlsation);
    this.dayNames = [0, 1, 2, 3, 4, 5, 6].map((dayNr) => Vue.$date.now().day(dayNr + this.dayStartOfWeek).format('dd'));
  },
  methods: {
    addUnit(amount: number, unit: OpUnitType) {
      const dateObj = this.$date(`${this.innerVisibleYear}-${this.innerVisibleMonth}-${this.focusedDay}`);
      const newDateObj = dateObj.add(amount, unit);
      this.innerVisibleMonth = newDateObj.month() + 1;
      this.innerVisibleYear = newDateObj.year();
    },
    selectDate(tile: DayTileType) {
      this.selectedDate = this.$date(`${tile.year}-${tile.month}-${tile.day}`);
      this.focusedDay = this.selectedDate.date();
      this.$emit('input', this.selectedDate.format('YYYY-MM-DD'));
    },
    moveFocusByDay(amount: number) {
      const dateObj = this.$date(`${this.innerVisibleYear}-${this.innerVisibleMonth}-${this.focusedDay}`);
      const newDateObj = dateObj.add(amount, 'day');
      this.focusedDay = newDateObj.date();
      this.innerVisibleMonth = newDateObj.month() + 1;
      this.innerVisibleYear = newDateObj.year();
      this.$nextTick(() => {
        let tileRef = this.$refs[`${this.innerVisibleYear}-${this.innerVisibleMonth}-${this.focusedDay}`] as Vue;
        if (tileRef) {
          if (Array.isArray(tileRef) && tileRef.length > 0) {
            tileRef = tileRef[0] as any;
          }
          (tileRef as any).navigatedUsingKeyboard = true;
          const el = (tileRef.$el ?? {}) as HTMLElement;
          el.focus();
        }
      });
    },
  },
});
